import { headerWithCtas } from '@/data/sanity/fragments'
import cmsSettings from '../cmsSettings'

export const fields = `
  _type,
  _id,
  ${cmsSettings()},
  sectionBackground,
  ${headerWithCtas.fragment('header')}
`

export const fragment = (name = 'emailSignup') => `${name}{ ${fields} }`

const exported = {
  fields,
  fragment,
}

export default exported
